import { render, staticRenderFns } from "./WalletBalance.vue?vue&type=template&id=95f38c00"
import script from "./WalletBalance.vue?vue&type=script&lang=js"
export * from "./WalletBalance.vue?vue&type=script&lang=js"
import style0 from "./WalletBalance.vue?vue&type=style&index=0&id=95f38c00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports